import React from "react";

import OkcLoader from "../OkcLoader";

import "./index.scss";

const PageLoading = () => (
	<div className="page-loading">
		<OkcLoader />
	</div>
);

export default PageLoading;



// WEBPACK FOOTER //
// ./src/shared/components/PageLoading/index.jsx